import { Button } from '@/components/ui/button';
import { ExternalLink, Bug } from 'lucide-react';
import { NuvemshopConnectionHandlers } from '../types';
interface NuvemshopConnectionStateProps extends NuvemshopConnectionHandlers {}
export const NuvemshopConnectionState = ({
  handleConnectNuvemshop,
  isConnecting
}: NuvemshopConnectionStateProps) => {
  const handleDebugInfo = () => {
    console.log('🔧 [DEBUG] INFORMAÇÕES DE DEBUG:');
    console.log('🔧 [DEBUG] URL atual:', window.location.href);
    console.log('🔧 [DEBUG] User Agent:', navigator.userAgent);
    console.log('🔧 [DEBUG] Cookies habilitados:', navigator.cookieEnabled);
    console.log('🔧 [DEBUG] LocalStorage disponível:', typeof Storage !== "undefined");

    // Verificar se há informações de debug salvas
    const debugInfo = localStorage.getItem('nuvemshop_debug_info');
    if (debugInfo) {
      try {
        const parsed = JSON.parse(debugInfo);
        console.log('🔧 [DEBUG] Info salva:', parsed);
      } catch (e) {
        console.log('🔧 [DEBUG] Erro ao parsear info salva:', e);
      }
    } else {
      console.log('🔧 [DEBUG] Nenhuma info de debug salva');
    }

    // Verificar se há parâmetros de callback na URL
    const urlParams = new URLSearchParams(window.location.search);
    const hasCallbackParams = urlParams.has('code') || urlParams.has('state');
    console.log('🔧 [DEBUG] Parâmetros de callback na URL:', hasCallbackParams);
    if (hasCallbackParams) {
      console.log('🔧 [DEBUG] Parâmetros encontrados:', {
        code: urlParams.get('code'),
        state: urlParams.get('state'),
        store_id: urlParams.get('store_id'),
        error: urlParams.get('error')
      });
    }
    alert('Informações de debug foram logadas no console. Abra as ferramentas de desenvolvedor (F12) para ver.');
  };
  return <div className="text-center space-y-4 py-8">
      <div className="space-y-2">
        <h3 className="text-lg font-medium">Conectar com Nuvemshop</h3>
        <p className="text-sm text-muted-foreground">
          Clique no botão abaixo para conectar sua loja Nuvemshop automaticamente.
          Você será redirecionado para autorizar o acesso à sua loja.
        </p>
      </div>
      
      <div className="flex flex-col gap-2 items-center">
        <Button onClick={handleConnectNuvemshop} disabled={isConnecting} className="w-full max-w-xs">
          <ExternalLink className="h-4 w-4 mr-2" />
          {isConnecting ? 'Conectando...' : 'Conectar com Nuvemshop'}
        </Button>
        
        
      </div>
      
      <div className="text-xs text-muted-foreground mt-4 p-3 bg-gray-50 rounded-md">
        <p className="font-medium mb-1">Problemas com a conexão?</p>
        <ul className="text-left space-y-1">
          <li>• Abra o console do navegador (F12) para ver logs detalhados</li>
          <li>• Tente em modo anônimo/incógnito</li>
          <li>• Verifique se pop-ups estão bloqueados</li>
          <li>• Faça logout da Nuvemshop se estiver logado</li>
        </ul>
      </div>
    </div>;
};